import { IsEmail, IsOptional, IsString, IsUUID } from 'class-validator';
import { WaitlistStatus } from '../../enums';

export class GetWaitlistEntriesDto {
	@IsOptional()
	@IsUUID()
	event_id?: string;

	@IsOptional()
	@IsEmail()
	user_email?: string;
}

export class CreateWaitlistDto {
	@IsUUID()
	event_id: string;

	@IsOptional()
	@IsEmail()
	user_email?: string;

	@IsOptional()
	@IsString()
	user_name?: string;
}

export class WaitlistEntryDto {
	id: string;
	event_id: string;
	user_email: string;
	user_name: string;
	status: WaitlistStatus;
	created_date: string;
	updated_date: string;
}
